import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslations } from "../../providers/useTranslations";
import { OptionalConsentRadioGroup } from "./OptionalConsentRadioGroup";
import styles from "./OptionalConsents.module.scss";
export const OptionalConsents = ({ purposes = [], disabled }) => {
    const { __ } = useTranslations();
    if (!purposes.length) {
        return null;
    }
    return (_jsxs("div", { className: styles.container, children: [_jsx("div", { className: styles.headline, children: __("auth.registration.consents.optional.description") }), purposes.map(({ id, description, default: defaultValue }) => {
                return (_jsx(OptionalConsentRadioGroup, { defaultValue: defaultValue, purposeDescription: description, purposeName: id, disabled: disabled }, id));
            })] }));
};
//# sourceMappingURL=OptionalConsents.js.map